import { Tab, Spinner } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { DashboardApi, EDepartment } from "../../../api";
import { ERoutes } from "../../../ERoutes";
import { BackButton, PageBase, ProtectedTabs } from "../../../components";
import { useApiService, useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";
import { MyAssignedTasksList } from "./MyAssignedTasksList";
import { DashboardSportPage } from "../sport/DashboardSportPage";
import { AccountingTaskList } from "../accounting/AccountingTaskList";
import { DogAwaitingUpdateTaskList } from "../dogUpdate/DogAwaitingUpdateTaskList";
import { DogTransientTitlesList } from "../sport/DogTransientTitlesList";
import { DogHealth } from "../health/DogHealthDashboardPage";
import { JudgeBreedValidationPage } from "../judge/JudgeBreedValidationPage";

export interface IMyTodoListItemPageProps {}

export const MyTodoListItemPage: React.FunctionComponent<IMyTodoListItemPageProps> = (props) => {
  const history = useHistory();
  const api = useApiService(DashboardApi);
  const { t } = useTl();
  const { tab } = useParams<{
    tab: string;
  }>();

  const [data, loading] = useApiEffect(() => api.getuserDepartements());

  React.useEffect(() => {
    if (!tab) history.push(`${ERoutes.assignedRequests}/assigned`);
  }, [history, tab]);

  return loading ? (
    <Spinner />
  ) : (
    <PageBase
      breadCrumbs={[
        {
          text: t(ETLCodes.AssignedRequests),
          route: ERoutes.assignedRequests,
        },
      ]}
    >
      <ProtectedTabs
        id="TabsAssignedRequests"
        onChange={(newTabId) => history.push(`${ERoutes.assignedRequests}/${newTabId}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.assignedRequests} />
        <Tab id="assigned" title={t(ETLCodes.Requests)} panel={<MyAssignedTasksList />} />
        <Tab id="affix" title={t(ETLCodes.RequestAffix)} disabled />
        <Tab
          id="compatibily"
          title={t(ETLCodes.Compatibility)}
          panel={<AccountingTaskList isAssigned={true} />}
          disabled={!data?.includes(EDepartment.Accounting)}
        />
        <Tab
          id="updateDog"
          title={t(ETLCodes.DogUpdate)}
          panel={<DogAwaitingUpdateTaskList isAssigned sportSection={false} />}
        />
        <Tab
          id="pedigree"
          title={t(ETLCodes.Pedigree)}
          panel={<DogTransientTitlesList searchUnassignedTitles={false} />}
        />
        <Tab
          id="health"
          title={t(ETLCodes.Health)}
          panel={<DogHealth searchUnassigned={false} />}
          disabled={!data?.includes(EDepartment.Health)}
        />
        <Tab
          id="sport"
          title={t(ETLCodes.Sport)}
          panel={
            <div>
              <DashboardSportPage searchUnassignedTitles={false} />
              <DogAwaitingUpdateTaskList isAssigned sportSection />
            </div>
          }
          disabled={!data?.includes(EDepartment.Sport)}
        />
        <Tab id="judge" title={t(ETLCodes.Judge)} panel={<JudgeBreedValidationPage />} />
      </ProtectedTabs>
    </PageBase>
  );
};
